import { Dialog } from './Dialog';
import { Alert } from './ModalAlert';
import { ModalBackButton, ModalCloseButton, ModalResizeButton } from './ModalButtons';
import { Confirm } from './ModalConfirm';
import { ModalTitleBar } from './ModalTitleBar';

export const Modal = Object.assign(Dialog, {
  TitleBar: ModalTitleBar,
  CloseButton: ModalCloseButton,
  BackButton: ModalBackButton,
  ResizeButton: ModalResizeButton,
  Confirm,
  Alert,
});
